export default __webpack_public_path__ + "static/SoftwareIDEv2.1-5a4c3c5b4f71558cdc970e1f76a2c06a.png";